import React from 'react';
import { AlertTriangle, ExternalLink } from 'lucide-react';
import { describePurchaseQbBill } from '../../utils/purchaseQbBillStatus';
import type { PurchaseQbBillStatus } from '../../types/purchasing';
import './PurchaseQbBillIndicator.css';

export default function PurchaseQbBillIndicator({
  status,
  url,
  message,
  vendorName,
  amount,
  invoiceNumber,
  compact = false,
}: {
  status?: PurchaseQbBillStatus | string | null;
  url?: string | null;
  message?: string | null;
  vendorName?: string | null;
  amount?: number | null;
  invoiceNumber?: string | null;
  compact?: boolean;
}) {
  const view = describePurchaseQbBill({
    status,
    url,
    message,
    vendorName,
    amount,
    invoiceNumber,
  });
  if (!view) return null;

  if (compact) {
    const chip = (
      <span className={`po-qb-chip po-qb-chip--${view.tone}`}>
        {view.tone === 'warn' ? <AlertTriangle size={10} aria-hidden /> : null}
        {view.url ? (
          <a href={view.url} target="_blank" rel="noreferrer">
            {view.chip}
          </a>
        ) : (
          view.chip
        )}
      </span>
    );
    return chip;
  }

  return (
    <div className={`po-qb-bill po-qb-bill--${view.tone}`}>
      <div className="po-qb-bill-title">
        {view.tone === 'warn' ? <AlertTriangle size={14} aria-hidden /> : null}
        {view.title}
      </div>
      <p className="po-qb-bill-detail">{view.detail}</p>
      {view.url ? (
        <a className="fin-secondary-btn" href={view.url} target="_blank" rel="noreferrer">
          <ExternalLink size={14} />
          Open QuickBooks bill
        </a>
      ) : null}
    </div>
  );
}
